/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Hilldun_ApprovalsInputs */

const en_nav_hilldun_approvals = /** @type {(inputs: Nav_Hilldun_ApprovalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilldun approvals`)
};

/**
* | output |
* | --- |
* | "Hilldun approvals" |
*
* @param {Nav_Hilldun_ApprovalsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_hilldun_approvals = /** @type {((inputs?: Nav_Hilldun_ApprovalsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Hilldun_ApprovalsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_hilldun_approvals(inputs)
});